import React from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';

import { changeEmail } from '../../../../Header/Account/thunk';
import * as selectorsUser from '../../../selector';

import TextFieldComp from '@/components/TextFieldComp';
import { uiSlice } from '@/domain/ui/redux';
import { Email } from '@/domain/user/service/entity/valueObjects/email';

type FormType = {
  email: string,
}

/**
 * プロパティ
 */
export type Props = {
  /** ひらくか */
  isOpen: boolean,
  /** 閉じる */
  close: () => void,
}

const EditEmailDialog: React.FC<Props> = ({ isOpen, close }) => {
  const dispatch = useDispatch();
  const user = useSelector(selectorsUser.userSelector);
  const currentEmail = user?.attributes?.email || '';
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<FormType>({
    defaultValues: {
      email: '',
    },
  });
  const onSubmit = (input: FormType) => {
    if (input.email !== currentEmail) {
      dispatch(changeEmail(input.email));
      close();
    } else {
      dispatch(uiSlice.actions.setMessage({ key: 'warning', content: 'メールアドレスが現在のものと同じです' }));
    }
  };
  const content = `現在のメールアドレスは「${currentEmail}」です。`;
  return (
    <Dialog open={isOpen}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogTitle style={{ textAlign: 'center' }}>
          メールアドレス変更
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            以下に新規メールアドレスを入力して「変更ボタン」を押してください。
          </DialogContentText>
          <DialogContentText>
            {content}
          </DialogContentText>
          <TextFieldComp
            type={Email.type}
            control={control}
            rules={Email.validationRule}
            name={Email.key}
            label={Email.label}
            placeholder={Email.placeholder}
            errors={errors}
          />
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center' }}>
          <Button type="submit">
            変更する
          </Button>
          <Button onClick={() => close()}>閉じる</Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default EditEmailDialog;
